App.directive('toogleMenu', ['$state', function($state) { 
    return {
        restrict: 'A',
        scope: {
            target: '@',
            route: '@'
        },
        link: function(scope, elm) {
            $(elm[0]).on('click', function() {

                if (!scope.target) {
                    $('ul.menu').velocity("stop", true).velocity({height: 0});
                    $('ul.menu').removeClass('open');
                    $('.sidebar').removeClass('opened');
                    return 0;
                }

                var target = $(scope.target);
                var h = target[0].scrollHeight;

                if ($('.sidebar').hasClass('opened')) {
                    if ($(target).hasClass('open')) {
                        toggle();

                    } else {
                        $('ul.menu').not(target).removeClass('open');
                        $('ul.menu').not(target).velocity("stop", true).velocity({
                                height: 0
                            }, {
                                complete: function() {
                                    toggle();
                                }
                            }
                        );
                    }
                } else {
                    toggle();
                }

                function toggle() {
                    if (!$(target).hasClass('open')) {

                        // load route
                        if (scope.route) {
                            $state.go(scope.route);
                        }

                        $(target).addClass('open');
                        $('.sidebar').addClass('opened');
                        $(target).velocity("stop", true).velocity({height: h});
                    } else {
                        $(target).removeClass('open');
                        $('.sidebar').removeClass('opened');
                        $(target).velocity("stop", true).velocity({height: 0});
                    }
                }
            });

        }
    }
}]);
